import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { handleRequest } from "../../helpers/handleAsync";
import { ICombo } from "../../types/combo";
import comboService from "../../services/comboService";
export interface IComboState {
    comboStore: ICombo[],
    comboSelected: ICombo
}
const initialState: IComboState = {
    comboStore: [],
    comboSelected: {} as ICombo
}

const getComboList = createAsyncThunk(
    'combo/getList',
    async (_, { dispatch }) => {
        const [res, err] = await handleRequest(comboService.getCombos());
        if (!res || err || res.status !== 1) throw new Error(err);
        dispatch(setComboList(res.data));
        return res.data;
    }
)

export const comboSlice = createSlice({
    name: 'comboStore',
    initialState,
    reducers: {
        setComboList(state, action: PayloadAction<ICombo[]>) {
            state.comboStore = action.payload
        },
        setComboSelected(state, action: PayloadAction<ICombo>) {
            state.comboSelected = action.payload
        }
    }
})
export const comboPrvSliceActions = { getComboList };
export const { setComboList, setComboSelected } = comboSlice.actions;
export default comboSlice.reducer;